import { useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import TrustMarquee from "@/components/TrustMarquee";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import Audience from "@/components/Audience";
import QuoteForm from "@/components/QuoteForm";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";

export default function Landing() {
  const [prefill, setPrefill] = useState({ service: "", userType: "" });

  const scrollToQuote = (opts = {}) => {
    if (opts.service || opts.userType) {
      setPrefill({ service: opts.service || "", userType: opts.userType || "" });
    }
    const el = document.getElementById("quote");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Nav onCtaClick={() => scrollToQuote()} />
      <Hero onCtaClick={() => scrollToQuote()} />
      <TrustMarquee />
      <HowItWorks />
      <Services onPick={(s) => scrollToQuote({ service: s })} />
      <Audience onPick={(u) => scrollToQuote({ userType: u })} />
      <QuoteForm prefill={prefill} />
      <FAQSection />
      <Footer />
    </div>
  );
}
